import { Card, DatePicker, Row, Col } from "antd";
import { ReactComponent as CalendarIcon } from "../../Icons/vuesax/calendar.svg";
import { Dayjs } from "dayjs";

interface DateOfServiceFilterProps {
  selectedServiceDateFrom?: Dayjs | null;
  selectedServiceDateTo?: Dayjs | null;
  onChangeDates: (selectedServiceDateFrom: Dayjs | null, selectedServiceDateTo: Dayjs | null) => void;
}

const DateOfServiceFilter = ({
      selectedServiceDateFrom = null,
      selectedServiceDateTo = null, 
      onChangeDates 
    }: DateOfServiceFilterProps) => {

    const handleFromChange = (value: any) => {
      onChangeDates(value, selectedServiceDateTo);
    };

    const handleToChange = (value: any) => {
      onChangeDates(selectedServiceDateFrom, value);
    };

    return (
      <Card
        styles={{ body: { padding: "16px" } }}
        className={`service-filter-card`}>
        <span className="service-filter-title">Date of Service</span>
        <Row justify="space-between" align="middle" style={{ marginTop: "10px" }} gutter={[8,12]}>
          <Col xs={24} sm={12} >
            <label htmlFor="date-from-service" className="input-label">
              From
            </label>
            <DatePicker
              id="date-from-service"
              className="custom-datepicker"
              value={selectedServiceDateFrom}
              placeholder="MM/DD/YYYY"
              format="MM/DD/YYYY"
              suffixIcon={<CalendarIcon className="calendar-icon" />}
              onChange={handleFromChange}
            />
          </Col>
          <Col xs={24} sm={12} >
            <label htmlFor="date-to-service" className="input-label">
              To
            </label>
            <DatePicker
              id="date-to-service"
              className="custom-datepicker"
              value={selectedServiceDateTo}
              placeholder="MM/DD/YYYY"
              format="MM/DD/YYYY"
              suffixIcon={<CalendarIcon className="calendar-icon" />}
              onChange={handleToChange}
            />
          </Col>
        </Row>
      </Card>
    );
  };

export default DateOfServiceFilter;
